export { HomeDeliveryIcon } from "./home-delivery";
